import "./initialed-form.js";
import "./digital-certificate.js";
import "./get-final-pdf.js";
import { initCarousel } from "./book-interior-carousel";
import { initLightbox } from "./interior-images";

const run = () => {
  const interiorImages = document.querySelectorAll(
    ".supapress-interior-images__image img",
  );
  const bookCover = document.querySelectorAll(
    ".book-wrapper__top-section--image .sp__the-cover img",
  );

  if (interiorImages.length > 0) {
    initCarousel(interiorImages);
    initLightbox(interiorImages);
  }
  if (bookCover) {
    initLightbox(bookCover);
  }
  scrollTo();
};

document.addEventListener("DOMContentLoaded", () => {
  try {
    run();
  } catch (err) {
    console.error(err);
  }
});
